import React from 'react';
import HowToNoodleStyled, { GIF, Title, Para } from './HowToNoodle.styled';
import HowToGif from './images/HowToGif.gif';

const HowToNoodle = () => (
  <HowToNoodleStyled>
    <GIF src={`${HowToGif}`} alt="How to Noodle example" />
    <Title>
      <span>How to</span> Noodle
    </Title>
    <Para>
      Just <strong>select</strong> the square you want to move, then select
      where you'd like to <strong>move it</strong> to!
    </Para>
    <Para>
      When you put the Noodle in the correct order, <strong>you win!</strong>
    </Para>
    <Para>
      But watch out for that dastardly <strong>timer...</strong>
    </Para>
  </HowToNoodleStyled>
);

export default HowToNoodle;



// WEBPACK FOOTER //
// ./src/components/atoms/HowToNoodle/HowToNoodle.js